import React from 'react';
import { PageLocation } from '../../../shared/enum/PageLocation';
import { HomeContext } from '../HomeContext';


interface IHomeItemProps {
    pageLocation?: PageLocation,
    pageLocationList?: PageLocation[],
    children: React.ReactChild
}

export function HomeItem({ pageLocation, pageLocationList, children }: IHomeItemProps) {
    const homeContext = React.useContext(HomeContext);
    return (
        <>
            {!!pageLocation && homeContext.pageLocation === pageLocation &&
                children}
            {!!pageLocationList && pageLocationList.includes(homeContext.pageLocation) &&
                children}
        </>
    );
}